import { createLazyFileRoute } from "@tanstack/react-router";

import { WorkflowsPage } from "@/features/admin/routes/Workflows";

export const Route = createLazyFileRoute("/_auth/admin/workflows/")({
  component: WorkflowsPage,
});
